
// The app's full-screen loader: the RunDiffusion mark alone on the deep
// background while the app signs you in, and over a dimmed page (with what
// it's doing, when the caller says) while an action runs. It fades out when
// done.
import Vue from 'vue';
import { mapGetters, mapState } from 'vuex';
import MarkLoader from '@/components/base/MarkLoader.vue';

export default Vue.extend({
	name: 'GlobalLoader',
	data () {
		return {
			// the last message, kept through the fade out (the store clears it on hide)
			shownMessage: null as string | null,
		};
	},
	computed: {
		...mapGetters([
			'isLoggingIn',
		]),
		...mapState([
			'loader',
		]),
		isShown (): boolean {
			return !!(this.loader.show || this.isLoggingIn);
		},
	},
	watch: {
		'loader.message': {
			immediate: true,
			handler (message: string | null | undefined) {
				if (message) this.shownMessage = message;
			},
		},
		isShown (shown: boolean) {
			if (shown && !this.loader.message) this.shownMessage = null;
		},
	},
	components: {
		MarkLoader,
	},
});
